<template>
    <div>
        <span v-if="state === OrderState.Confirmed || state === OrderState.PickedUp|| state === OrderState.ReadyForPickup"
              class="badge badge-success ml-1 py-4 px-5">
            <order-state-icon class="mr-1" :status="state"/>
            {{ __('orders.states.' + state) }}
        </span>
        <span v-else-if="state === OrderState.Rejected || state === OrderState.Refunded"
              class="badge badge-danger ml-1 py-4 px-5">
            <order-state-icon class="mr-1" :status="state"/>
            {{ __('orders.states.' + state) }}
        </span>
        <span v-else-if="state === OrderState.WaitForIntegration"
              class="badge badge-secondary bg-light-secondary text-dark ml-1 py-4 px-5">
            {{ __('orders.states.' + state) }}
        </span>
        <span v-else class="badge badge-primary ml-1 py-4 px-5">
            <order-state-icon class="mr-1" :status="state"/>
            {{ __('orders.states.' + state) }}
        </span>
    </div>
</template>

<script>
import OrderStateIcon from './OrderStateIcon';
import Spinner from 'vue-simple-spinner';
import {OrderState} from '@composables/orderStates';

export default {
    components: {
        OrderStateIcon,
        Spinner,
    },

    props: {
        state: String,
        paid: Boolean,
    },

    computed: {
        OrderState() {
            return OrderState;
        },
    },
};
</script>
